import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { useQuery } from 'react-apollo'

import UnitWritingPracticeListPlaceholder from 'src/pages/UnitWritingPracticeList/UnitWritingPracticeListPlaceholder'
import UnitWritingPracticeList from 'src/pages/UnitWritingPracticeList/UnitWritingPracticeList'
import DataFetchError from 'src/ui/DataFetchError/DataFetchError'

const FETCH_WRITING_PRACTICES = gql`
  query WRITING_PRACTICES(
    $unitId: ID!
    $l1Code: LanguageEnum!
    $l2Code: LanguageEnum!
  ) {
    curriculum(native: $l1Code, learning: $l2Code) {
      unit(id: $unitId) {
        writingPrompts {
          name
          coverImageUrl
          hasEntry
          entry {
            url
          }
        }
      }
    }
  }
`
const UnitWritingLazy = ({ l1Code, l2Code, unitId }) => {
  const response = useQuery(FETCH_WRITING_PRACTICES, {
    variables: {
      l1Code,
      l2Code,
      unitId,
    },
  })
  const { data, loading } = response

  const writing = data?.curriculum?.unit?.writingPrompts

  if (loading) {
    return <UnitWritingPracticeListPlaceholder />
  }

  if (writing) {
    return <UnitWritingPracticeList items={writing} />
  }

  return <DataFetchError graphQLResponse={response} />
}

UnitWritingLazy.propTypes = {
  l1Code: PropTypes.string.isRequired,
  l2Code: PropTypes.string.isRequired,
  unitId: PropTypes.string.isRequired,
}

export default UnitWritingLazy
